import axios from "axios";
import { toast } from "react-toastify";
import { API_ERROR_500 } from "../../../../../config";
import { setLoading, getStageScreen } from "../../../../../redux";
import {
  GET_REVIEW_REQUEST,
  GET_REVIEW_SUCCESS,
  GET_REVIEW_FAILURE,
  GET_ESIGN_SUCCESS,
  GET_ESIGN_FAILURE,
  GET_DOCUMENT_ID,
} from "./type";

export const getReviewData = () => {
  const portal_domain = window.sessionStorage.getItem("portal_domain");
  const API_URL = portal_domain
    ? portal_domain.substring(0, portal_domain.length - 1)
    : "";
  const token = window.sessionStorage.getItem("token");
  const headers = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      Authorization: `Basic ${token}`,
    },
  };
  return async (dispatch) => {
    dispatch(setLoading(true));
    dispatch({ type: GET_REVIEW_REQUEST });
    try {
      const resp = await axios.post(
        `${API_URL}/api/method/kyc_customizations.apis.kyc_flow.api.get_kyc_detail`,
        {},
        headers
      );
      dispatch({ type: GET_REVIEW_SUCCESS, payload: resp?.data?.data[0] });
      dispatch(setLoading(false));
    } catch (error) {
      const { response } = error;
      dispatch({ type: GET_REVIEW_FAILURE });
      dispatch(setLoading(false));
    }
  };
};

export const getDocumentId = () => {
  const portal_domain = window.sessionStorage.getItem("portal_domain");
  const API_URL = portal_domain
    ? portal_domain.substring(0, portal_domain.length - 1)
    : "";
  const token = window.sessionStorage.getItem("token");
  const headers = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      Authorization: `Basic ${token}`,
    },
  };
  return async (dispatch) => {
    try {
      const resp = await axios.post(
        `${API_URL}/api/method/kyc_customizations.esign.get_esign_doc_id.endpoint`,
        {},
        headers
      );
      console.log('resp?.data?.data', resp?.data?.data)
      dispatch({ type: GET_DOCUMENT_ID, payload: resp?.data?.data });
      //   response = {
      //     "kyc_doc_id": "DID231226153736955NMF1T8YQQM77MH",
      //     "kra_doc_id": "DID231226153739330PYE9WA83Y3CU4M"
      // }
    } catch (error) {
      const { response } = error;
    }
  };
};

export const handleReview = (callback) => {
  const portal_domain = window.sessionStorage.getItem("portal_domain");
  const API_URL = portal_domain
    ? portal_domain.substring(0, portal_domain.length - 1)
    : "";
  const token = window.sessionStorage.getItem("token");
  const headers = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      Authorization: `Basic ${token}`,
    },
  };
  return async (dispatch) => {
    dispatch(setLoading(true));
    try {
      const resp = await axios.post(
        `${API_URL}/api/method/kyc_customizations.apis.kyc_verification.api.review_kyc`,
        {},
        headers
      );
      console.log("resp", resp.data?.data);
      if (resp.data?.data?.redirect_esign === 1) {
        // dispatch(setLoading(false));
        callback();
      } else {
        toast.success("Submitted for eSignature");

        dispatch(requestForEsign());
        // dispatch(setLoading(false));
      }
    } catch (error) {
      const { response } = error;
      dispatch(setLoading(false));
    }
  };
};

export const checkEsignUrl = (successCb, failedCb) => {
  const portal_domain = window.sessionStorage.getItem("portal_domain");
  const API_URL = portal_domain
    ? portal_domain.substring(0, portal_domain.length - 1)
    : "";
  const token = window.sessionStorage.getItem("token");
  const headers = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      Authorization: `Basic ${token}`,
    },
  };
  return async (dispatch) => {
    dispatch(setLoading(true));
    try {
      const resp = await axios.post(
        `${API_URL}/api/method/kyc_customizations.apis.kyc_verification.api.get_esign_redirect_url`,
        {},
        headers
      );
      console.log("resp", resp.data?.data);
      if (resp.data?.data?.redirect_url_kyc && resp.data?.data?.redirect_url_kyc_2) {
        successCb();
        dispatch({ type: GET_ESIGN_SUCCESS, payload: resp.data?.data });
        dispatch(setLoading(false));
        dispatch(getStageScreen());
      } else {
        dispatch({ type: GET_ESIGN_FAILURE, payload: null });
        failedCb();
      }
    } catch (error) {
      dispatch(setLoading(false));
      dispatch({ type: GET_ESIGN_FAILURE, payload: null });
    }
  };
};

export const requestForEsign = () => {
  const portal_domain = window.sessionStorage.getItem("portal_domain");
  const API_URL = portal_domain
    ? portal_domain.substring(0, portal_domain.length - 1)
    : "";
  const token = window.sessionStorage.getItem("token");
  const headers = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      Authorization: `Basic ${token}`,
    },
  };
  return async (dispatch) => {
    dispatch(setLoading(true));
    try {
      const resp = await axios.post(
        `${API_URL}/api/method/kyc_customizations.apis.kyc_verification.api.request_for_esign`,
        {},
        headers
      );
      dispatch(setLoading(false));
      //Temporary fix Confirm for Review ticket from Jigar for this
      // dispatch(getStageScreen());
    } catch (error) {
      const { response } = error;
      if (response?.data?.message) {
        toast.error(response?.data?.message);
      } else {
        toast.error(API_ERROR_500);
      }
      dispatch(setLoading(false));
    }
  };
};
